<template>
  <div>
    <new-widget-dialog
      ref="newWidgetDialog"
      @addWidget="addWidget"
      :hidden-widgets="hiddenWidgets"
    />
    <widget-form-dialog ref="widgetFormDialog" @submit="formDialogSubmitted" />
  </div>
</template>
<script>
import WidgetFormDialog from './widgetFormDialog/'
import NewWidgetDialog from './newWidgetDialog'

export default {
  props: {
    widgets: Array,
    errors: [Array, String],
    hiddenWidgets: {
      type: Array,
      default: () => []
    }
  },
  beforeMount() {
    this.fetchData()
  },
  components: {
    WidgetFormDialog,
    NewWidgetDialog
  },
  methods: {
    fetchData() {
      this.$store.dispatch('fetchWidgetTypes')
    },
    editWidget(widgetIndex) {
      const widget = this.widgets[widgetIndex]
      const errors = this.errors && this.errors[widgetIndex]
      this.$refs.widgetFormDialog.openDialog(widget, errors)
    },
    openNewWidgetDialog(widgetRow, widgetColumn) {
      this.$refs.newWidgetDialog.openDialog(widgetRow, widgetColumn)
    },
    addWidget(newWidget) {
      this.widgets.push(newWidget)
    },
    formDialogSubmitted(newForm, oldForm) {
      const index = this.widgets.indexOf(oldForm)
      this.widgets.splice(index, 1, newForm)
    }
  }
}
</script>
